import styled from "styled-components";

export const BottomSheetSelectBox = styled.div<any>`
  width: auto;
  padding: 10px 10px;
  white-space: nowrap;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 6px;
  border: 1px solid ${(props) => props.theme.colors.checkBoxBorder};
  border-radius: 4px;

  input {
    display: none;
  }

  p {
    font-size: 1.6rem;
    font-weight: 550;
    color: ${(props) => props.theme.colors.checkBox};
  }

  &.selected {
    border: 1px solid ${(props) => props.theme.colors.primary};
    background: ${(props) => props.theme.colors.checkBoxBg};

    p {
      color: ${(props) => props.theme.colors.primary};
    }
  }

  @media (max-width: 412px) {
    padding: 9px;
  }
`;
